import { AGENT_USER_PREMIUM_PLAN } from "../constants/common";

// Must match isPremiumAgentPlan in the API (src/helpers/userPlan.helper.js).
const PREMIUM_AGENT_PLANS = new Set(
  [AGENT_USER_PREMIUM_PLAN, "Pro Preferred", "Trial"].map((plan) =>
    plan.toLowerCase(),
  ),
);

export const isPremiumAgentPlan = (planName) =>
  Boolean(planName) &&
  PREMIUM_AGENT_PLANS.has(String(planName).trim().toLowerCase());

const PREMIUM_AGENT_PLAN_IDS = new Set([5, 6, 7, 8, 9]);

export const isPremiumAgentPlanId = (planId) => PREMIUM_AGENT_PLAN_IDS.has(Number(planId));
